export default __webpack_public_path__ + "static/media/capsule-gray.21fdc70f.png";